<template>
    <div class='box-header'>
        <div class='header'>
            <div class='header_left'>
                <div class='header_noti_icon'></div>
                <div class='header_message'>
                    {{ headerMessage }}
                </div>
            </div>
            <div class='header_right'>
                <div class='header_time'>{{dateTime}}</div>
                <button @click="callEmployee" 
                    class='header_call_employee_icon'>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
  import {MixinAllowedMenu} from '@/assets/js/mixinAllowedMenu';
  import api from '@/assets/js/api';
  import moment from 'moment';


  export default {
    name: 'TouchHeader',
    components: {
    },
    mixins: [MixinAllowedMenu],
    props: {
        center: {
            type: Object,
        },
        setting: {
            type: Object,
        },
    },
    data() {
      return {
            headerMessage: '',
            dateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
      };
    },
    created() {
        setInterval(() => this.getNow(), 1000)
    },
    mounted() {
        this.init();
    },
    computed: {
        centerId() {
            return this.$store.getters['auth/cId'];
        },
    },
    methods: {
        async init() {
            try {
                this.headerMessage = !this.setting.headerMessage ? `안녕하세요! ${this.center.centerName}입니다.` : this.setting.headerMessage;
            } catch (error) {
                console.error(error);
            }
        },
        getNow() {
            this.dateTime = moment().format('YYYY-MM-DD HH:mm:ss');
        },
        callEmployee() {
            return api.post(`${process.env.VUE_APP_SSE_URL}/sse/touch/monitor/alert/employee`, {
                centerId: this.centerId
            });
        },
    },
  };
</script>

<style lang='scss' scoped>
    .box-header {
        display: flex;
        justify-content: center;
    }

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 6.4rem;
        padding: 0 2.4rem;
        background-color: white;
        width: 100%;

        // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
        @media (min-width: 1200px) {
            height: 4.8rem;
            padding: 0 2rem;
        }
    }

    .header_left {
        display: flex;
        align-items: center;
        gap: .8rem;

        // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
        @media (min-width: 1200px) {
            gap: 0.8rem;
        }
    }

    .header_right {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .header_noti_icon {
        width: 2.4rem;
        height: 2.4rem;
		background: url(/img/icons/touch_monitor_noti.png) no-repeat;
        background-position: center !important;
        background-size: contain;

        // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
        @media (min-width: 1200px) {
            width: 3.2rem;
            height: 3.2rem;
            background-size: contain;
        }
    }

    .header_call_employee_icon {
        width: 178px;
        height: 56px;
		background: url(/img/icons/touch_monitor_call_employee.png) no-repeat;
        background-position: center !important;
    }

    .header_message {
        //styleName: Body4 | 18px;
        font-family: Noto Sans CJK KR;
        font-size: 1.6rem;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.6000000238418579px;
        color: #333333;

        // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
        @media (min-width: 1200px) {
            font-size: 1.6rem;
            font-weight: 500;
            line-height: 1.6rem;
        }
    }

    .header_time {
        font-family: Noto Sans CJK KR;
        font-size: 1.4rem;
        font-weight: 400;
        letter-spacing: -0.005em;
        color: #777777;

        // 테스크탑 (가로 해상도가 769px 보다 작은 화면에 적용)
        @media (max-width: 768px) {
            display: none;
        }

        // 라지 (가로 해상도가 1200px 보다 큰 화면에 적용)
        @media (min-width: 1200px) {
            font-size: 1.6rem;
        }
    }
</style>
